module.exports = __webpack_public_path__ + "static/media/hangup-off.b6e33442.svg";